<template>
  <div class="page-notifications">
<!--    <div class="filters">-->
<!--      <div class="filters__btns">-->
<!--        <button :class="[filters.group === 9 && 'active']" @click="filters.group = 9">{{ $t('all') }}</button>-->
<!--        <button :class="[filters.group === 2 && 'active']" @click="filters.group = 2">-->
<!--          {{ $t('Notifications.academic') }}-->
<!--        </button>-->
<!--        <button :class="[filters.group === 1 && 'active']" @click="filters.group = 1">-->
<!--          {{ $t('Notifications.general') }}-->
<!--        </button>-->
<!--      </div>-->
<!--    </div>-->
    <NotificationsContent :in-modal="$route.query.modal"/>
    <ModalConfirmDelete/>
    <ModalTurnOff/>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import moment from 'moment'
import groupBy from 'lodash/groupBy'

import NotificationsList from '@/components/notifications/NotificationsList'
import { withUi } from '@/components/ui'
import SelectCustom from "@/components/form/SelectCustom";
import Checkbox from '@/components/form/Checkbox.vue'
import NewCheckbox from '@/components/NewCheckbox.vue'
import Modal from '@/components/modals/Modal.vue'
import ModalConfirmDelete from '@/components/notifications/ModalConfirmDelete.vue'
import ModalTurnOff from '@/components/notifications/ModalTurnOff.vue'
import NotificationsContent from '@/components/notifications/NotificationsContent.vue'

export default {
  name: 'Notifications',
  mixins: [withUi],
  components: { NotificationsContent, ModalTurnOff, ModalConfirmDelete, Modal, NewCheckbox, Checkbox, SelectCustom, NotificationsList },
  data(vm) {
    return {
      filterscustom: [],
      filters: {
        group: 1,
        sort: { id: 1, label: vm.$t('sort-options.new') },
      },
    }
  },
  computed: {
    logsFiltered() {
      const { group } = this.filters

      const logs = this.logsSorted

      return logs.filter((x) => {
        if (group === 1) {
          // filter General
          return x.type.id === 1
        }
        if (group === 2) {
          // filter Academic
          return x.type.id === 2
        }

        return x
      })
    },
    logsSorted() {
      const { sort } = this.filters
      const logs = this.logs

      if (sort && sort.id === 1) {
        // ascending sort
        return logs.sort((a, b) => a.created_at - b.created_at)
      }
      if (sort && sort.id === 2) {
        // descending sort
        return logs.sort((a, b) => b.created_at - a.created_at)
      }

      return this.logs
    },
    logsGroupped() {
      if (this.logs && !this.logs.length) return []

      const formatMask = 'DD MMM'

      const dates = this.logsFiltered.map((x) => moment(x.created_at).format(formatMask))
      const datesGrouped = Object.keys(groupBy(dates))

      return datesGrouped.map((date) => {
        const logs = this.logsFiltered.filter((log) => moment(log.created_at).format(formatMask) === date)
        return {
          date,
          logs,
        }
      })
    },
    selectOptions() {
      return [
        { id: 1, label: this.$t('sort-options.new') },
        { id: 2, label: this.$t('sort-options.old') },
      ]
    },
    ...mapGetters('events', ['notificationNew']),
    ...mapState('events', ['logs']),
  },
  methods: {
    update() {
      this.getNotifications().then(({ data }) => {
        this.setLogsIdsViewed(data.map(({ id }) => id))
      })
    },
    handleSelectChange(arrayID) {
      if(arrayID.length) {
        this.filters.sort = this.selectOptions.find((item) => item.id == arrayID[0])
      } else {
        this.filters.sort = this.selectOptions[0]
      }
    },
    ...mapMutations('events', ['setLogsIdsViewed']),
    ...mapActions('notifications', ['getNotifications']),
  },
  created() {
    if (!this.logs.length || this.notificationNew) {
      this.update();
    }

  },
  watch: {
    notificationNew(v) {
      if (v) {
        this.update()
      }
    },
  },
}
</script>

<style lang="scss">
#content.page-notifications {
  //padding: 0 20px;
  .group {
    margin-bottom: 15px;
    &__date {
      margin: 0 0 15px;
      font-weight: 700;
      &__day {
        font-size: 15px;
        color: $darkGrey;
      }
      &__weekday {
        margin-left: 10px;
        font-size: 12px;
        color: $dark;
      }
    }
  }

  .filters {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }

  @include mobile {
    padding: 0 20px;
    .filters {
      margin-top: 0;
      justify-content: inherit;
    }
    .notifications-mobile-filter {
      width: 100%;
      margin: 30px 42px 34px 42px;
    }
  }
}
</style>
